module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": "数据源"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("当前数据选择")]), _vm._v(" "), _vm._l((_vm.caseList), function(caseData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.changeCase(caseData)
        }
      }
    }, [(_vm.activeCase.key === caseData.key) ? _c('img', {
      attrs: {
        "src": require("assets/checked-2.png"),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("assets/unchecked-2.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(caseData.name) + "\n            ")])])
  }), _vm._v(" "), (_vm.caseList.length === 0) ? _c('span', {
    staticClass: "app-note"
  }, [_vm._v("无可选case数据，请先导入！")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("数据导入")]), _vm._v(" "), _vm._l((_vm.importWays), function(wayData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.activeImportWayKey = wayData.key
        }
      }
    }, [(wayData.key === _vm.activeImportWayKey) ? _c('img', {
      attrs: {
        "src": require("assets/checked-2.png"),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("assets/unchecked-2.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(wayData.name) + "\n            ")])])
  }), _vm._v(" "), _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.startImport(false)
      }
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统提醒",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("当前case尚未存储，请确定是否丢弃该case。")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("返回存储")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.startImport(true)
      }
    }
  }, [_vm._v("丢弃并导入")])], 1)])], 2)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0bb809e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/tobacco/import_to.vue
// module id = 1007
// module chunks = 1